var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6742 9.24391C15.5847 9.15434 15.4621 9.09777 15.3207 9.09777C15.0473 9.09777 14.821 9.32405 14.821 9.59746L14.821 14.8206L9.59782 14.8206C9.3244 14.8206 9.09813 15.0469 9.09813 15.3203C9.09813 15.5937 9.3244 15.82 9.59782 15.82L15.3207 15.82C15.5941 15.82 15.8204 15.5937 15.8204 15.3203L15.8204 9.59746C15.8204 9.45604 15.7638 9.33348 15.6742 9.24391Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.594 14.8868L7.66027 6.95309C7.46699 6.75981 7.14644 6.75981 6.95316 6.95309C6.75989 7.14636 6.75989 7.46692 6.95316 7.66019L14.8869 15.5939C15.0802 15.7872 15.4007 15.7872 15.594 15.5939C15.7873 15.4007 15.7873 15.0801 15.594 14.8868Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDown);
export default __webpack_public_path__ + "static/media/price-down.fbff89504ec2f8910760cdb04de51f9d.svg";
export { ForwardRef as ReactComponent };